import styled from 'styled-components';

export const Content = styled.div``;

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  color: var(--primary-dark);
  margin: 20px 0;
`;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Div = styled.div`
  &.active {
    color: var(--primary-green);
  }
  &.inactive {
    color: #ff646480;
  }
  &.captal {
    text-transform: capitalize;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f8fc;
  padding: 7px 10px;
  border-radius: 12px;
  margin: 0 15px;
`;

export const FilterButoons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Button = styled.button`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--white);
  background: #8a93ac;
  min-width: 68px;
  border: none;
  height: 28px;
  border-radius: 8px;
  padding: 0 8px;

  &.active {
    background: var(--primary-dark-two);
  }
`;

export const Icon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border-radius: 40px;
  margin: auto;
  /* padding: 10px; */

  &.child {
    width: 32px;
    height: 32px;
    border-radius: 40px;
    overflow: hidden;
  }
`;

export const ArrowIcon = styled.div`
  width: 17px;
  height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #8a93ac;
  line-height: 0;
  border-radius: 40px;
  overflow: hidden;
  /* padding: 10px; */
`;

export const Image = styled.img`
  max-width: 100%;
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const TitleTd = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 10px;

  &.child {
    padding-left: 20px;
  }

  &.level-2 {
    padding-left: 20px;
  }

  &.level-3 {
    padding-left: 40px;
  }

  &.level-4 {
    padding-left: 60px;
  }

  &.level-5 {
    padding-left: 80px;
  }

  &.level-6 {
    padding-left: 100px;
  }

  &.active {
    .child-arrow-icon {
      background: #1dbaaf;
      transform: rotate(180deg);
      svg {
        stroke: #fff !important;
      }
    }
  }
`;
